import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'vc-chat-list',
  templateUrl: './chat-list.component.html',
  styleUrls: ['./chat-list.component.scss']
})
export class ChatListComponent implements OnInit {
  @Input()
  channelId: string;

  @Output()
  channelSelected: EventEmitter<string> = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
